<div class="flex flex-col gap-1">
  <h3
    class="leading-5 line-clamp-1 font-semibold text-on-surface dark:text-on-surface-darkmode hidden sm:block"
  >
    {{ 'cockpit.locations.listEntry.descriptionTitle' | transloco }}
  </h3>
  <div class="inline-flex justify-start items-center gap-1.5 flex-wrap content-center">
    @if (
      location().data?.electricityEnergyInterfaceCount ||
      location().data?.gasEnergyInterfaceCount ||
      location().data?.supplierContractCount
    ) {
      @if (location().data?.electricityEnergyInterfaceCount) {
        <div
          class="px-2 py-1 rounded-full outline outline-1 outline-offset-[-1px] outline-outline flex justify-center items-center gap-1"
        >
          <div class="bg-secondary-soft-outline h-2 w-2 rounded-full"></div>
          <div class="justify-start text-xs font-medium leading-4">
            @if (location().data?.electricityEnergyInterfaceCount === 1) {
              {{ 'cockpit.locations.listEntry.electricityInterfaces.one' | transloco }}
            } @else {
              {{ location().data?.electricityEnergyInterfaceCount }}
              {{ 'cockpit.locations.listEntry.electricityInterfaces.other' | transloco }}
            }
          </div>
        </div>
      }
      @if (location().data?.gasEnergyInterfaceCount) {
        <div
          class="px-2 py-1 rounded-full outline outline-1 outline-offset-[-1px] outline-outline flex justify-center items-center gap-1"
        >
          <div class="bg-warning h-2 w-2 rounded-full"></div>
          <div class="justify-start text-xs font-medium leading-4">
            @if (location().data?.gasEnergyInterfaceCount === 1) {
              {{ 'cockpit.locations.listEntry.gasInterfaces.one' | transloco }}
            } @else {
              {{ location().data?.gasEnergyInterfaceCount }}
              {{ 'cockpit.locations.listEntry.gasInterfaces.other' | transloco }}
            }
          </div>
        </div>
      }
      @if (location().data?.supplierContractCount) {
        <div
          class="px-2 py-1 rounded-full outline outline-1 outline-offset-[-1px] outline-outline flex justify-center items-center gap-1"
        >
          <div class="justify-start text-xs font-medium leading-4">
            @if (location().data?.supplierContractCount === 1) {
              {{ 'cockpit.locations.listEntry.contracts.one' | transloco }}
            } @else {
              {{ location().data?.supplierContractCount }}
              {{ 'cockpit.locations.listEntry.contracts.other' | transloco }}
            }
          </div>
        </div>
      }
    } @else {
      <span
        class="text-sm font-normal text-on-surface-subtle dark:text-on-surface-subtle-darkmode flex items-center gap-1"
      >
        <ng-icon name="heroExclamationCircle" size="20" class="!block flex-none" />
        {{ 'cockpit.locations.listEntry.noLinkedEntities' | transloco }}
      </span>
    }
  </div>
</div>
